import type { User, UserRole } from '@oppy/omniv2-utils';

interface DecodedToken {
  permissions?: string[];
  'oppy/roles'?: string | string[];
  sub?: string;
  email?: string;
  name?: string;
  [key: string]: unknown;
}

const base64UrlDecode = (str: string): string => {
  const normalizedBase64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const paddingLength = (4 - (normalizedBase64.length % 4)) % 4;
  const paddedBase64 = normalizedBase64 + '='.repeat(paddingLength);
  return atob(paddedBase64);
};

export function decodeJWTPayload(token: string): DecodedToken | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid JWT format');
    }
    const [, payloadBase64] = parts;
    const payloadJson = base64UrlDecode(payloadBase64);
    return JSON.parse(payloadJson);
  } catch (err) {
    console.error('Failed to decode JWT:', err);
    return null;
  }
}

export function mapAuth0ToUser(
  auth0User: { sub?: string; email?: string; name?: string },
  tokenPayload: DecodedToken | null,
): User {
  const role = (tokenPayload?.['oppy/roles']?.[0] || 'User') as UserRole;

  return {
    id: auth0User.sub ?? '',
    email: auth0User.email,
    name: auth0User.name,
    role,
  };
}
